'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FacebookIcon = require('../../FacebookIcon');

var _FacebookIcon2 = _interopRequireDefault(_FacebookIcon);

var _InstagramIcon = require('../../InstagramIcon');

var _InstagramIcon2 = _interopRequireDefault(_InstagramIcon);

var _TwitterIcon = require('../../TwitterIcon');

var _TwitterIcon2 = _interopRequireDefault(_TwitterIcon);

var _YouTubeIcon = require('../../YouTubeIcon');

var _YouTubeIcon2 = _interopRequireDefault(_YouTubeIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialLogos = function SocialLogos() {
  return _react2.default.createElement(
    'div',
    { className: 'socialLogos' },
    _react2.default.createElement(
      'a',
      { href: 'https://www.facebook.com/Surfline/', target: '_blank', rel: 'noopener noreferrer' },
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_FacebookIcon2.default, null)
      )
    ),
    _react2.default.createElement(
      'a',
      { href: 'https://www.instagram.com/surfline/', target: '_blank', rel: 'noopener noreferrer' },
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_InstagramIcon2.default, null)
      )
    ),
    _react2.default.createElement(
      'a',
      { href: 'https://www.youtube.com/surfline', target: '_blank', rel: 'noopener noreferrer' },
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_YouTubeIcon2.default, null)
      )
    ),
    _react2.default.createElement(
      'a',
      { href: 'https://twitter.com/surfline', target: '_blank', rel: 'noopener noreferrer' },
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_TwitterIcon2.default, null)
      )
    )
  );
};

exports.default = SocialLogos;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/SurflineFooter/SocialLogos/SocialLogos.js
// module id = 328
// module chunks = 0